import { Component, OnInit } from '@angular/core';
import {AuthService} from "../../auth.service";
import {Router} from "@angular/router";

@Component({
  selector: 'app-content',
  templateUrl: './content.component.html',
  styleUrls: ['./content.component.css']
})
export class ContentComponent implements OnInit {

  constructor(
    private auth:AuthService,
    private router: Router
  ) { }

  ngOnInit() {
    const isLogin = this.auth.authenticateAccount();
    if(!isLogin){
        this.router.navigate(['/login']);
    }
  }

}



// WEBPACK FOOTER //
// /home/sotsys211/work/src/ecard_new/backend/src/app/layout/content/content.component.ts